import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { MatIconModule } from "@angular/material/icon";

export interface NotificationSnackbarData {
    icon: string;
    text: string;
}

@Component({
    template: `
        <mat-icon>{{ data.icon }}</mat-icon>
        {{ data.text }}
        <button
            mat-button
            color="accent"
            (click)="dismiss()"
        >
            Dismiss
        </button>
    `,
    styles: [
        `
            :host {
                display: flex;
                align-items: center;
            }

            mat-icon {
                margin-right: 0.5rem;
            }

            button {
                margin-left: auto;
            }
        `,
    ],
    imports: [
        MatIconModule,
        MatButtonModule,
    ],
})
export class NotificationSnackbarComponent {
    private snackbarRef = inject<MatSnackBarRef<NotificationSnackbarComponent>>(MatSnackBarRef);
    public data = inject<NotificationSnackbarData>(MAT_SNACK_BAR_DATA);

    public dismiss() {
        this.snackbarRef.dismiss();
    }
}
